export const productCategories = function (data) {
  const category = [...new Set(data.map((arr) => arr.category))];

  return category.map((arr) => data.find((itr) => itr.category === arr));
};
